import axios, { isAxiosError } from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_BACK_URL,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    },
});

export const setAuthToken = (token: string | null) => {
    if (token) {
        api.defaults.headers.common.Authorization = token;
    } else {
        delete api.defaults.headers.common.Authorization;
    }
};

/** Достаёт человекочитаемое сообщение из ошибки запроса. */
export const getErrorMessage = (
    err: unknown,
    fallback = 'Что-то пошло не так'
) => {
    if (isAxiosError(err)) {
        const data = err.response?.data;
        if (typeof data === 'string' && data) return data;
        if (data && typeof data === 'object' && 'message' in data) {
            return String(data.message);
        }
        if (!err.response) return 'Сервер недоступен';
    }
    return fallback;
};

export default api;
